import { LAYOUTS } from "@voltmoney/types";
import SharedPropsService from "../../../SharedPropsService";
import { ROUTE } from "../../../routes";
import { SizeTypeTokens, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { errorInstrument, goBack, leadToPayment, resetPage } from "./action";
import { getBankPNGUrl, getContactUsDetails, showDSPVirtualAccount } from "../../../configs/utils";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { REPAYMENT_COLLECTION_TYPE } from "../../../configs/constants";
export const template = (height, contactUsDetails, selectedAmount, lenderAccountId, virtualAccountData, chargesDue, paymentData, userName, collectionType, bankImageUri, showVirtualAccountDsp) => ({
    layout: {
        id: ROUTE.CONFIRM_AND_PAYMENT,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "referenceSpace", type: WIDGET.SPACE
            },
            {
                id: "confirmAndPayment",
                type: WIDGET.CONFIRM_AND_PAYMENT,
            },
        ],
    },
    datastore: {
        referenceSpace: { size: SizeTypeTokens.NONE },
        confirmAndPayment: {
            height,
            contactUsDetails,
            selectedAmount,
            lenderAccountId,
            virtualAccountData,
            chargesDue,
            paymentData,
            userName,
            bankImageUri,
            collectionType,
            showVirtualAccountDsp,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.CONFIRM_AND_PAYMENT,
                payload: {}
            },
            leadToPaymentAction: {
                type: ACTION.DEFAULT_PAYMENT,
                routeId: ROUTE.CONFIRM_AND_PAYMENT,
                payload: {
                    collectionType,
                    isHavingShortfall: paymentData?.isHavingShortfall
                }
            },
            trackPaymentTypeSelectionAction: {
                type: ACTION.ERROR_INSTRUMENT,
                routeId: ROUTE.CONFIRM_AND_PAYMENT,
                payload: {},
            },
        },
    },
});
export const confirmAndPaymentPageMf = {
    onLoad: async ({ network, instrumentTrack, getHeight }, { selectedAmount, collectionType }) => {
        const user = await SharedPropsService.getUser();
        const contactUsDetails = await getContactUsDetails();
        const lenderAccountId = user?.linkedApplications[0].lenderAccountId;
        const chargesDue = user?.linkedCredits[0]?.chargesDue;
        const paymentData = await SharedPropsService.getPaymentData();
        const userName = user?.user.fullName;
        const showVirtualAccountDsp = await showDSPVirtualAccount();
        const response = await network.get(`${api.repaymentBankAccountDetails}${user?.linkedCredits[0]?.creditId}`, {
            headers: await getAppHeader(),
        });
        const virtualAccountData = response?.data?.principleRepaymentBankAccountDetails;
        const bankImageUri = getBankPNGUrl(virtualAccountData?.bankCode);
        if (collectionType === REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION) {
            instrumentTrack("CONFIRM_AND_PAY_PAGE_VIEWD", { "source": 'interest' });
        }
        else if (collectionType === REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT) {
            instrumentTrack("CONFIRM_AND_PAY_PAGE_VIEWD", { "source": 'shortfall' });
        }
        else if (collectionType === REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT) {
            instrumentTrack("CONFIRM_AND_PAY_PAGE_VIEWD", { "source": 'principal' });
        }
        return Promise.resolve(template(getHeight(), contactUsDetails, selectedAmount, lenderAccountId, virtualAccountData, chargesDue, paymentData, userName, collectionType, bankImageUri, showVirtualAccountDsp));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.DEFAULT_PAYMENT]: leadToPayment,
        [ACTION.RESET_PAGE]: resetPage,
        [ACTION.ERROR_INSTRUMENT]: errorInstrument,
    },
};
